import { ThunkAction, ThunkDispatch } from "redux-thunk";
import * as storeTypes from "../storeTypes";
import * as storeActions from "../storeActions";
import * as calendarTaskService from "../../services/calendarTaskService";
import { handleApiError } from "../storeEffects";
import { CalendarTaskAction, calendarTaskFailure, calendarTaskSuccess } from "./storeCalendarTask";

export type CalendarTaskThunkDispatch = ThunkDispatch<storeTypes.IApplicationState, null, CalendarTaskAction>

export const getCalendarTaskPage = (): ThunkAction<any, storeTypes.IApplicationState, any, any> => (dispatch, getState) => {
    dispatch(storeActions.fetchStart());
    return calendarTaskService.getCalendarTaskPage()
        .then(
            calendarTaskPage => {
                dispatch(calendarTaskSuccess(calendarTaskPage));
            },
            error => {
                handleApiError(error, dispatch);
                dispatch(calendarTaskFailure());
            })
        .finally(() =>
            dispatch(storeActions.fetchEnd())
        );
};